import _ from 'lodash'

import { connect } from 'react-redux'

import Chart, { IChartProps } from './Chart'
import { IChartPoint, IState, } from './types'

export const threadKeys: string[] = [
  'total-threads',
]

const mapStateToProps = (state: IState): IChartProps => {
  const data: IChartPoint[] = _
    .chain(state.chartPoints)
    .filter((point: IChartPoint) => point.chartType === 'THREADS')
    .sortBy('timestamp')
    .value()

  return {
    data,
    keys: threadKeys,
  }
}

export default connect(mapStateToProps)(Chart)



// WEBPACK FOOTER //
// ./src/Threads.tsx